import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import Checkbox from "utils/Checkbox";
import { getApiDataService } from "../../../services/apiServices";
import { PAYMENT_PROVIDER_API } from "../../../services/CONSTANTS";
import { toast } from "react-toastify";

function CreatePaymentAccountModal(props) {
  // Initialize state with default values for accountName, accountNo, and status
  const [accountName, setAccountName] = useState(null);
  const [accountNo, setAccountNo] = useState(null);
  const [paymentProviderId, setPaymentProviderId] = useState(null);
  const [paymentProviders, setPaymentProviders] = useState([]);
  const [types, setTypes] = useState([]);

  const [isLoading, setIsLoading] = useState(props.isLoading);
  useEffect(() => {
    fetchPaymentProviders();
  }, []);

  const fetchPaymentProviders = () => {
    setIsLoading(true);
    getApiDataService(PAYMENT_PROVIDER_API)
      .then((response) => {
        setPaymentProviders(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  // Handler functions for updating account information
  const handleAccountNameChange = (event) => {
    setAccountName(event.target.value);
  };

  const handleAccountNoChange = (event) => {
    setAccountNo(event.target.value);
  };

  const handlePaymentProviderChange = (event) => {
    setPaymentProviderId(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);
    let data = {
      account_name: accountName,
      account_no: accountNo,
      payment_provider_id: paymentProviderId,
      types: types
    };
    if(types.length == 0){
      toast.error("Please select at least one type");
      setIsLoading(false);
    }
    else{
      props.onSubmit(data);
    }
  };

  const handleCheckboxChange = (value) => {
    if(types.includes(value)){
      setTypes(types.filter(item => item !== value))
    }else{
      setTypes([...types, value])
    }
    console.log(types)

  }

  return (
    <Modal isOpen={true} toggle={props.onClose}>
      <ModalHeader toggle={props.onClose}>
        <h4>Create Payment Account</h4>
      </ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label for="status">Payment Provider</Label>
            <Input
              type="select"
              name="status"
              id="status"
              onChange={handlePaymentProviderChange}
            >
              <option value="">Select Payment Provider</option>
              {paymentProviders.map((paymentProvider) => {
                return (
                  <option value={paymentProvider.id}>
                    {paymentProvider.name}
                  </option>
                );
              })}
            </Input>
          </FormGroup>
          <FormGroup>
            <Label for="accountName">Account Name</Label>
            <Input
              type="text"
              name="accountName"
              id="accountName"
              onChange={handleAccountNameChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="accountNo">Account No</Label>
            <Input
              type="text"
              name="accountNo"
              id="accountNo"
              onChange={handleAccountNoChange}
            />
          </FormGroup>
          <FormGroup>
            <Label for="type">Type</Label> 
            <Checkbox status={types.includes("app")} label="app" forType="app" onClick={()=>handleCheckboxChange('app')}/>
            <Checkbox status={types.includes("pos")} label="pos" forType="pos" onClick={()=>handleCheckboxChange('pos')}/>
            
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          No
        </button>
        {isLoading == false && (
          <button className="btn btn-success" onClick={handleSubmit}>
            Save
          </button>
        )}
        {isLoading == true && (
          <button className="btn btn-success" disabled="disabled">
            Uploading...
          </button>
        )}
      </ModalFooter>
    </Modal>
  );
}

export default CreatePaymentAccountModal;
